import * as blUrls from 'lib/urls'
import * as BLConstants from 'shared/constants'

export const mobileNav = [
  { name: 'Registry', href: blUrls.howToCreateABabyRegistryPath },
  { name: 'Store', href: blUrls.catalogPath },
  { name: 'Guides', href: blUrls.helloBabyPath },
  { name: 'About Us', href: blUrls.aboutPath },
  { name: 'Help', href: blUrls.faqPath, newWindow: true },
  { name: 'Contact Us', href: blUrls.contactUsPath, newWindow: true },
]

export const getNav = (loggedIn) => [
  {
    heading: 'Registry',
    href: blUrls.howToCreateABabyRegistryPath,
    links: [
      { name: 'Why Babylist', href: blUrls.whyBabyListPath },
      { name: 'Find Registry', href: blUrls.findPath },
      { name: 'Create Registry', href: blUrls.newRegistryPath },
      {
        name: 'Install Babylist Button',
        href: blUrls.addItemsPath,
        render: loggedIn,
      },
      {
        name: 'Transfer Another Registry',
        href: blUrls.registryExternalPath,
        render: loggedIn,
      },
      { name: 'Baby Registry Checklist', href: blUrls.checklistPath },
      {
        name: `${BLConstants.CONFIG.store.registryDiscountPctDisplay} Registry Discount`,
        href: blUrls.registryDiscountPath,
      },
    ],
  },
  {
    heading: 'About Us',
    href: blUrls.aboutPath,
    links: [
      { name: 'Team', href: blUrls.teamPath },
      { name: 'Our Story', href: blUrls.aboutPath },
      {
        name: 'Babylist Health Advisory Board',
        href: blUrls.healthAdvisoryBoardPath,
      },
      {
        name: 'Experiences',
        href: blUrls.experiencesPath,
      },
      { name: 'Press', href: blUrls.pressPath },
      { name: 'Jobs', href: blUrls.jobsPath },
      { name: 'Terms of Use', href: blUrls.termsOfUsePath },
      { name: 'Privacy Policy', href: blUrls.privacyPolicyPath },
      { name: 'Cookie Notice', href: blUrls.cookiesPath },
      { name: 'CCPA Notice', href: blUrls.ccpaPath },
    ],
  },
  {
    heading: 'Guides',
    href: blUrls.helloBabyPath,
    links: [
      {
        name: 'Best Car Seats',
        href: blUrls.helloBabyPostPath('best-car-seats'),
      },
      {
        name: 'Best Strollers',
        href: blUrls.helloBabyPostPath('best-strollers'),
      },
      {
        name: 'Best Baby Carriers',
        href: blUrls.helloBabyPostPath('best-baby-carriers'),
      },
      {
        name: 'Best Baby Bottles',
        href: blUrls.helloBabyPostPath('best-baby-bottles'),
      },
      {
        name: 'Best Baby Products',
        href: blUrls.helloBabyPostPath('best-baby-products'),
      },
      {
        name: 'Pregnancy Week by Week',
        href: blUrls.helloBabyPostPath('pregnancy-week-by-week'),
      },
    ],
  },
  {
    heading: 'Support',
    href: blUrls.faqPath,
    newWindow: true,
    links: [
      { name: 'Help', href: blUrls.faqPath, newWindow: true },
      { name: 'Contact Us', href: blUrls.contactUsPath, newWindow: true },
      {
        name: 'Shipping',
        href: 'https://help.babylist.com/hc/en-us/sections/360009762154-Babylist-Shipping',
        newWindow: true,
      },
      { name: 'Returns', href: blUrls.returnsPath, newWindow: true },
    ],
  },
]
